module.exports = __webpack_public_path__ + "assets/img/live4_app.7e8f0d90.png";